import React from 'react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53266912084305:1';
export function HeroSection() {
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  return <section id="hero" className="py-12 px-4 bg-white" data-id="element-89">
      <div className="max-w-4xl mx-auto text-center animate-fade-in-up" data-id="element-90">
        {/* Headline */}
        <h1 className="text-[26px] md:text-4xl font-bold text-black mb-4 leading-tight" data-id="element-91">
          "¡No me lo creo! Lo acabo de probar y NO HA HABIDO GRITOS. Ha sido
          mágico 😭" - María G.
        </h1>

        {/* Subheadline */}
        <p className="text-[18px] md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-92">
          Descarga hoy el manual de 15 min para desactivar el berrinche digital
          y recuperar tu salón por solo 6,95€.
        </p>

        {/* Product Image */}
        <div className="mb-8 max-w-lg mx-auto" data-id="element-93">
          <img src="https://cdn.magicpatterns.com/uploads/kBX7T79CqC4oXKyjurDsGx/imagen_producto_y_bonos.png" alt="Protocolo Cero Gritos - Manual Digital y Bonos" className="w-full h-auto drop-shadow-xl rounded-xl" data-id="element-94" />
        </div>

        {/* CTA Area */}
        <div className="flex flex-col items-center gap-3 mb-6" data-id="element-95">
          <Button onClick={goToCheckout} className="animate-pulse-soft w-full md:w-auto text-lg py-4 px-8" data-id="element-96">
            DESCARGAR PROTOCOLO CERO GRITOS (6,95€)
          </Button>
          <p className="text-sm text-gray-600 font-medium" data-id="element-97">
            📥 Acceso inmediato tras el pago. Formato PDF optimizado para móvil.
          </p>
        </div>

        {/* Payment Badges */}
        <div className="flex flex-wrap justify-center gap-3 mt-4" data-id="element-98">
          {['Apple Pay', 'Google Pay', 'PayPal', 'Bizum'].map(method => <div key={method} className="px-4 py-2 bg-gray-50 border border-gray-200 rounded-md text-sm font-bold text-gray-600 shadow-sm" data-id="element-99">
              {method}
            </div>)}
        </div>
      </div>
    </section>;
}